import { SetFreespinsBetbarCommand } from "slotworks/commands/betbar/set-freespins-betbar-command";
import Components from "slotworks/components/components";
import PromptContent from "slotworks/components/prompt/prompt-content";
import Layers from "slotworks/graphics/layers/layers";
import AutoplayModel from "slotworks/model/autoplay/autoplay-model";
import Gamestate from "slotworks/model/game-state";
import { Services } from "slotworks/services/services";
import SmartUIFlags, { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import State from "slotworks/state-machine/states/state";

export default class EnterFreespins extends State {
    public onEnter() {
        super.onEnter();

        if (AutoplayModel.stopOnFeatureWin) {
            Services.autoplay.stop();
        }

        Components.celebrateWin.cleanup();
        Components.celebrateWin.hide();

        SmartUIFlags.set(SmartUIFlag.PROMPT, true);

        this.showPrompt();
    }

    public complete() {
        this.showFreespinsElements();

        SetFreespinsBetbarCommand();

        SmartUIFlags.set(SmartUIFlag.PROMPT, false);
        SmartUIFlags.set(SmartUIFlag.FREE_SPINS, true);

        super.complete();
    }

    // To set up custom options on a prompt, extend this, initialise your prompt and pass it to super
    protected showPrompt(prompt?: PromptContent, loadStage?: number) {
        if (!prompt && Layers.Prompts.hasAnyScene(["freespinswin", "freespins"])) {
            prompt = new PromptContent(["freespinswin", "freespins"]);
        }

        if (prompt) {
            const record = Gamestate.getCurrentGame().getCurrentRecord();

            prompt.setText("winMessage", Services.translations.get("fs.tri", { VALUE: record.getFreespinsWon() }));
            prompt.setText("value", record.getFreespinsWon().toString());

            Components.prompt.showPrompt(prompt, loadStage).then(() => this.complete());

        } else {
            this.complete();
        }
    }

    protected showFreespinsElements() {
        if (Layers.Background.hasScene("freespins")) {
            Layers.Background.setScene("freespins").execute();
        }
        if (Layers.MatrixBackground.hasScene("freespins")) {
            Layers.MatrixBackground.setScene("freespins").execute();
        }
        if (Layers.Header.hasScene("freespins")) {
            Layers.Header.setScene("freespins").execute();
        }
        Components.banner.setMode("freespins");
    }
}
